export type SeoTitles =
    | 'root'
    | 'demo'
    | 'login'
    | 'resetPassword'
    | 'sendPassword'
    | 'vacancies'
    | 'internshipDetailId'
    | 'vacancyDetailId'
    | 'projects'
    | 'register'
    | 'about'
    | 'news'
    | 'newsId'
    | 'education'
    | 'help'
    | 'advantagesConditions'
    | 'activate'
    | 'restore'
    | 'expiredToken'
    | 'blockAccount'
    | 'confirmRegistration'
    | 'cabinetId'
    | 'cabinetDetailId'
    | 'cabinetNotificationId'
    | 'cabinetResumeId'
    | 'cabinetMailingId'
    | 'cabinetFavouritesId'
    | 'cabinetSettingsId'
    | 'contacts'
    | 'officeId'
    | 'internships'
    | 'scholarship'
    | 'schools'
    | 'policy'
    | 'error'
    | 'reportError'
    | 'askQuestion'
    | 'sendCv';

export function generateSEO(title: SeoTitles, addInfo?: string) {
    const SEO = {
        root: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description:
                'Найди работу мечты в инновационной компании BIOCAD. Зарегистрируйся на сайте, заполни профиль в личном кабинете и откликнись на желаемую вакансию или стажировку.',
        },
        demo: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description:
                'Найди работу мечты в инновационной компании BIOCAD. Зарегистрируйся на сайте, заполни профиль в личном кабинете и откликнись на желаемую вакансию или стажировку.',
        },
        login: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Войти в личный кабинет карьерного сайта компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        resetPassword: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description:
                'Найди работу мечты в инновационной компании BIOCAD. Зарегистрируйся на сайте, заполни профиль в личном кабинете и откликнись на желаемую вакансию или стажировку.',
        },
        sendPassword: {
            title: 'Молодежные проекты в BIOCAD, информация о сроках и условиях отбора',
            description:
                'Найди работу мечты в инновационной компании BIOCAD. Зарегистрируйся на сайте, заполни профиль в личном кабинете и откликнись на желаемую вакансию или стажировку.',
        },
        vacancies: {
            title: 'Открытые вакансии компании BIOCAD по всем направлениям деятельности',
            description:
                'Найди работу мечты в инновационной компании BIOCAD. Зарегистрируйся на сайте, заполни профиль в личном кабинете и откликнись на желаемую вакансию или стажировку.',
        },
        internshipDetailId: {
            title: 'Открытая стажировка компании BIOCAD с описанием обязанностей, требований и условий',
            description: `Вакансия ${addInfo} в компании BIOCAD. Выбери вакансию по направлению деятельности, заполни резюме и подай заявку.`,
        },
        vacancyDetailId: {
            title: 'Открытая вакансия компании BIOCAD с описанием обязанностей, требований и условий',
            description: `Вакансия в компании BIOCAD. ${addInfo}`,
        },
        projects: {
            title: 'Молодежные проекты в BIOCAD, информация о сроках и условиях отбора',
            description:
                'Актуальные программы для развития молодых специалистов в компании BIOCAD.',
        },
        register: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        about: {
            title: 'Информация о компании BIOCAD',
            description:
                'BIOCAD ведет полный цикл создания лекарственных препаратов: от поиска молекулы до массового производства и маркетинга. Компания фокусируется на препаратах для терапии онкологических, аутоиммунных и инфекционных заболеваний.',
        },
        news: {
            title: 'Актуальные новости компании BIOCAD',
            description:
                'Узнавай самые свежие новости компании BIOCAD! Подпишись на рассылку, чтобы всегда быть в курсе новых событий компании.',
        },
        newsId: {
            title: 'Страница новости компании BIOCAD',
            description: addInfo,
        },
        education: {
            title: 'Образование в сфере фармацевтической и биотехнологической с компанией BIOCAD',
            description:
                'BIOCAD сотрудничает с учебными организациями и образовательными проектами России, чтобы подготовить новое поколение лидеров российской фармацевтической и биотехнологической отрасли.',
        },
        help: {
            title: 'BIOCAD. Ответы на часто задаваемые вопросы',
            description:
                'Список наиболее часто задаваемых вопросов, ответы на которые могут вам помочь.',
        },
        advantagesConditions: {
            title: 'Преимущества и условия работы в компании BIOCAD',
            description: 'Присоединяйся к нашей команде! Результаты нашего труда спасают жизни!',
        },
        activate: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description: 'Карьера в инновационной биотехнологической компании BIOCAD.',
        },
        restore: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description: 'Карьера в инновационной биотехнологической компании BIOCAD.',
        },
        expiredToken: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description: 'Карьера в инновационной биотехнологической компании BIOCAD.',
        },
        blockAccount: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Ваш аккаунт в личном кабинете BIOCAD заблокирован. Необходимо сбросить пароль.',
        },
        confirmRegistration: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description: 'Подтвердите регистрацию в личном кабинете BIOCAD.',
        },
        cabinetId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetDetailId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetNotificationId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetResumeId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetMailingId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetFavouritesId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        cabinetSettingsId: {
            title: 'Личный кабинет соискателя на карьерном сайте компании BIOCAD',
            description:
                'Зарегистрируйся в личном кабинете на карьерном сайте компании BIOCAD, чтобы откликаться на вакансии и стать частью команды.',
        },
        contacts: {
            title: 'Офисы компании BIOCAD',
            description:
                'Узнайте больше об условиях труда в офисах и производствах компании BIOCAD в России. Найдите ближайший к вам офис на карте.',
        },
        officeId: {
            title: 'Современный офис компании BIOCAD',
            description:
                'Узнайте больше об условиях труда в офисах и производствах компании BIOCAD в России.',
        },
        internships: {
            title: 'Открытые стажировки компании BIOCAD, информация о сроках и условиях отбора.',
            description:
                'Хочешь попасть на стажировку в инновационную компанию BIOCAD? На странице можно найти информацию об условиях отбора, сроках проведения и подать заявку.',
        },
        scholarship: {
            title: 'Стипендия имени Ольги Гончаровой с компанией BIOCAD',
            description:
                'Описание стипендии, условия участия в конкурсе на стипендию имени Ольги Гончаровой с компанией BIOCAD.',
        },
        schools: {
            title: 'Программы для школьников от компании BIOCAD',
            description:
                'Узнайте больше о возможностях развития в сфере фармацевтики и биотехнологий с компанией BIOCAD для школьников.',
        },
        policy: {
            title: 'Карьера в инновационной биотехнологической компании BIOCAD',
            description: addInfo,
        },
        error: {
            title: 'Карьера в компании BIOCAD. Ошибка, такой страницы нет',
            description: 'Такой страницы нет. Но есть масса интересных вакансий, которые вас ждут!',
        },
        reportError: {
            title: 'Сообщить об ошибке на сайте компании BIOCAD',
            description: 'Заполните форму, если хотите сообщить о проблеме',
        },
        askQuestion: {
            title: 'Задайте вопрос специалистам по карьере в компании BIOCAD',
            description: 'У вас есть вопрос? - заполните форму и мы вам ответим',
        },
        sendCv: {
            title: 'Отправить резюме и начать карьеру в инновационной биотехнологической компании BIOCAD.',
            description:
                'Не нашли, что искали? Если вы не нашли интересующую вакансию, не отчаивайтесь — заполните эту форму и отправьте нам. Мы обязательно рассмотрим ваше резюме.',
        },
    };

    return SEO[title];
}
